<div>
  <p>ファイルの共有はUC+ファイルシェアで行われております</p>
  <div class="advertising-image">
     <a [href]="externalUrl"
       target="_blank"
       rel="noopener noreferrer"
       class="banner-link"
       [attr.aria-label]="'UC+ファイルシェアの詳細情報を新しいタブで開く'">
      <img [src]="bannerImageUrl"
           alt="UC+ファイルシェア"
           class="banner-image"
           loading="lazy"
           (error)="onImageError($event)">
    </a>
  </div>
</div>
